import QueryString from 'query-string';
import { requests, download } from '../helper/Agent';

export default class Case {
  static getCaseDataExport(query) {
    return requests.get(`/cases/export-data?${QueryString.stringify(query)}`);
  }

  static getAllTypesCases(query) {
    return requests.get(`/types-cases?${QueryString.stringify(query)}`);
  }

  static getAllSubTypesCases(query) {
    return requests.get(`/subtypes-cases?${QueryString.stringify(query)}`);
  }

  static getAllCases(query) {
    return requests.get(`/cases?${QueryString.stringify(query)}&sort_order=desc&sort_by=id`);
  }

  static getAllCasesDashboard(query) {
    return requests.get(`/cases/dashboard?${QueryString.stringify(query)}`);
  }

  static getExcelCases(fromDate, toDate) {
    return download.get(`/cases/download/me?onlyNotClosed=true&fromDate=${fromDate}&toDate=${toDate}`);
  }

  static getById(id) {
    return requests.get(`/contacts/${id}`);
  }

  static createCase(data) {
    return requests.post('/cases', data);
  }

  static createManyCases(data) {
    return requests.post('/cases/excel', data);
  }

  static createSubType(data) {
    return requests.post('/subtypes-cases', data);
  }

  static update(id, data) {
    return requests.put(`/contacts/${id}`, data);
  }

  static updateSubCase(id, data) {
    return requests.put(`/subtypes-cases/${id}`, data);
  }

  static getAllCasesMe(query) {
    return requests.get(`/cases/me?${QueryString.stringify(query)}&sort_order=desc&sort_by=id`);
  }

  static createCaseMe(data) {
    return requests.post('/cases/me', data);
  }

  static getCaseByIdMe(id) {
    return requests.get(`/cases/me/${id}`);
  }

  static getCaseSummary(query) {
    return requests.get(`/cases/summary?${QueryString.stringify(query)}`);
  }

  static getSignedDocument(id) {
    return requests.get(`/portability/download/${id}`);
  }

  static getDocumentS3(id) {
    return requests.get(`/trinidad/?name=${id}`);
  }

  static getAllS3Documents(id) {
    return requests.get(`/cases/s3files/${id}`);
  }

  static postDocumentS3(id, data) {
    return requests.post(`/trinidad/${id}`, data);
  }

  static getCaseById(id) {
    return requests.get(`/cases/${id}`);
  }

  static updateCaseMe(id, data) {
    return requests.put(`/cases/me/${id}`, data);
  }

  static updateCase(id, data) {
    return requests.put(`/cases/${id}`, data);
  }

  static updateCaseMany(data) {
    return requests.put('/cases/', data);
  }

  static removeCaseById(id) {
    return requests.del(`/cases/${id}`);
  }

  static removeSubCaseById(id) {
    return requests.del(`/subtypes-cases/${id}`);
  }

  static getRequestGrounds() {
    return requests.get("/requestGrounds");
  }

  static getRequestClassifications() {
    return requests.get("/requestClassifications");
  }
}
